<template>
	<component
		:is="tag"
		class="font-prenton-cond text-3xl tracking-2xl uppercase lg:text-4xl xl:text-5xl"
	>
		<slot></slot>
	</component>
</template>

<script lang="ts" setup>
withDefaults(
	defineProps<{
		tag?: string;
	}>(),
	{
		tag: "h4",
	},
);
</script>
